var Student = "Estudiante";
var jobRole = {
	"Job role": "Función",
	"Academic / Researcher": "Academia/Investigación",
	"Advisor / Consultant": "Consejería/Consultoría",
	"Business Executive": "Función ejecutiva de negocios",
	"Developer / Engineer": "Desarrollo/Ingeniería",
	"Entrepreneur (Founder/Co-Founder)": "Emprendimiento (fundadores/cofundadores)",
	"IT Executive": "Función ejecutiva de TI",
	"IT Professional or Technical Manager": "Gerencia técnica o profesional de TI",
	"Press / Media Analyst": "Prensa/Analista de medios",
	"Sales / Marketing": "Ventas/Marketing",
	Student: Student,
	"Solution or Systems Architect": "Arquitectura de soluciones o sistemas",
	"System Administrator": "Administración de sistemas",
	"Venture Capitalist": "Inversión en capital de riesgo"
};

export { Student, jobRole as default };
